// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2e-RY","column":"style_column__1ssL-","row":"style_row__2spH3"};